import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getPromissoryNotes } from 'services/promissory'

export default function useGetPromissory() {
    const { data, isLoading, refetch } = useQuery<IPromissory[]>(
        ['get-promissory'],
        getPromissoryNotes
    )
    return { data, isLoading }
}
